<template>
  <div
    v-show="isWinnerRendered"
    ref="winner-item-ref"
    class="winners_hist_sect"
  >
    <div class="left">
      <div class="left_1">
        <AvatarImage :src="item.avatar" alt="winner" />
      </div>

      <div class="left_2">
        <p class="name">{{ item.username }}</p>

        <p class="type">
          {{ $_translations.value[`page_get_started_section_winners_type_${ type }`] }}
        </p>

        <p class="price">{{ item.rewardDescription }}</p>
      </div>
    </div>
    <div class="right">
      <p class="date">{{ rewardDate }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import useDateHook from '@/hooks/useDate.js';
import useRenderAnimatedItemHook from '@/hooks/useRenderAnimatedItem.js';

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
  animated: {
    type: Boolean,
    default: false,
  },
});

const { formatDate } = useDateHook();

const [isWinnerRendered, renderWinner] = useRenderAnimatedItemHook('winner-item-ref');

const rewardDate = computed(() => formatDate(props.item.rewardDate));

onMounted(() => {
  renderWinner(props.animated);
});
</script>
